import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  // id: undefined, //AutoId, optional // Mã tự sinh
  da_hoan_thanh: undefined, //boolean, optional // Cho biết tour đã hoàn thành hay chưa, mặc đinh là chưa
  ten_tour: undefined, //string, required // Tên tour
  ten_doan: undefined,//string, optional // Tên đoàn
  dia_diem: {
    dia_diem: undefined, //string, optional // Địa điểm diễn ra hoặc địa điểm khởi đầu
    province_id: undefined, //IdRef, optional // Mã tỉnh
    lng: undefined, //double, optional, min: -180, max: 180 // Kinh độ (longitude)
    lat: undefined, //double, optional, min: -90, max: 90 // Vĩ độ (latitude)
  }, //optional // Thông tin địa điểm của tour

  hanh_trinh: [
    /* {
        thoi_gian_bat_dau: undefined, //datetime, optional // Từ ngày/thời điểm
        thoi_gian_ket_thuc: undefined, //datetime, optional // Đến ngày/thời điểm
        dia_diem: {
            dia_diem: undefined, //string, optional // Địa điểm diễn ra hoặc địa điểm khởi đầu
            province_id: undefined, //IdRef, optional // Mã tỉnh
            district_id: undefined, //IdRef, optional // Mã huyện
            lng: undefined, //double, optional, min: -180, max: 180 // Kinh độ (longitude)
            lat: undefined, //double, optional, min: -90, max: 90 // Vĩ độ (latitude)
        }, //optional // Địa điểm diễn ra hoặc địa điểm khởi đầu (nếu dia_diem_dich bằng undefined)

        dia_diem_dich: {
            dia_diem: undefined, //string, optional // Địa điểm diễn ra hoặc địa điểm khởi đầu
            province_id: undefined, //IdRef, optional // Mã tỉnh
            district_id: undefined, //IdRef, optional // Mã huyện
            lng: undefined, //double, optional, min: -180, max: 180 // Kinh độ (longitude)
            lat: undefined, //double, optional, min: -90, max: 90 // Vĩ độ (latitude)
        }, //optional // Địa điểm địa điểm đích

        tieu_de: undefined, //string, optional // Tiêu đề
        noi_dung: undefined, //string, optional // Nội dung
    } */ //optional // Hành trình
  ],

  thoi_gian_bat_dau: undefined, //datetime, optional // Thời gian bắt đầu
  thoi_gian_ket_thuc: undefined, //datetime, optional // Thời gian kết thúc
  so_luong_khach: {
    so_luong: undefined, //integer, optional, min: 0 // Tổng số lượng khách
    nguoi_lon: undefined, //integer, optional, min: 0 // Số người lớn
    tre_5_15: undefined, //integer, optional, min: 0 // Số trẻ từ 5 đến 15 tuổi
    tre_duoi_5: undefined, //integer, optional, min: 0 // Số trẻ dưới 5 tuổi
  }, //optional // Số lượng khách

  truong_doan: {
    truong_doan_id: undefined, //IdRef, optional // Mã trưởng đoàn
    ngay_sinh: {
      ngay: undefined, //integer, optional, min: 1, max: 31 // Ngày
      thang: undefined, //integer, optional, min: 1, max: 12 // Tháng
      nam: undefined, //integer, optional // Năm
      ngay_sinh: undefined, //datetime, optional // Ngày sinh
    }, //optional // Ngày tháng năm sinh

    dien_thoai: undefined, //string, optional // Số điện thoại
  }, //optional // Thông tin trưởng đoàn

  scan: {
    thong_tin_dieu_tour: [], //of IdRef, optional // Scan các ảnh chụp thông tin điều tour
    ho_so_tour: [] //of IdRef, optional // Các file đính kèm về hồ sơ Tour
  }, //optional // Các ảnh scan

  oto: {
    bien_so_xe: undefined, //string, optional // Biển số xe
    tai_xe: {
      ho_ten: undefined, //string, optional // Họ tên tài xế
      dien_thoai: undefined, //string, optional // Số điện thoại tài xế
    } //optional // Thông tin tài xế

  }, //optional // Thông tin ô tô

  khach_san: [
    /* {
    ten: undefined, //string, optional // Tên khách sạn
    dien_thoai: undefined, //string, optional // Số điện thoại người phụ trách
} */
  ], //optional // Danh sách Khách sạn

  nha_hang: [
    /* {
    ten: undefined, //string, optional // Tên Nhà hàng
    dien_thoai: undefined, //string, optional // Số điện thoại người phụ trách
} */
  ], //optional // Danh sách Nhà hàng

  anh: {
    anh_dai_dien: undefined,//IdRef, optional // Mã ảnh đại diện của tour (thường là ảnh vuông)
    anh_tour: [], //array of IdRef, optional // Danh sách ảnh chụp của tour
  }, //optional // Các thể loại ảnh của tour

  noi_dung: undefined, //string, optional // Nội dung thông tin tour
  khach_du_lich_cho_xac_nhan_ids: [], //IdRef, optional // Danh sách khách du lịch
  huong_dan_vien_ids: [], //IdRef, optional // Danh sách hướng dẫn viên
  // khach_du_lich_ids
  // huong_dan_vien_ids
  danh_sach_khach_du_lich_khong_tai_khoan:[],
};

// validation form
model.validForm = {
  da_hoan_thanh: [], //boolean, optional // Cho biết tour đã hoàn thành hay chưa, mặc đinh là chưa
  ten_tour: [ValidService.required, ValidService.checkSpaceString], //string, required // Tên tour
  ten_doan: [ValidService.required, ValidService.checkSpaceString],//string, optional // Tên đoàn
  dia_diem: {
    dia_diem: [ValidService.required, ValidService.checkSpaceString], //string, optional // Địa điểm diễn ra hoặc địa điểm khởi đầu
    province_id: [ValidService.requiredChange], //IdRef, optional // Mã tỉnh
    lng: [], //double, optional, min: -180, max: 180 // Kinh độ (longitude)
    lat: [], //double, optional, min: -90, max: 90 // Vĩ độ (latitude)
  }, //optional // Thông tin địa điểm của tour

  // hanh_trinh: [{
  //   thoi_gian_bat_dau: [], //datetime, optional // Từ ngày/thời điểm
  //   thoi_gian_ket_thuc: [], //datetime, optional // Đến ngày/thời điểm
  //   dia_diem: {
  //     dia_diem: [], //string, optional // Địa điểm diễn ra hoặc địa điểm khởi đầu
  //     province_id: [], //IdRef, optional // Mã tỉnh
  //     district_id: [], //IdRef, optional // Mã huyện
  //     lng: [], //double, optional, min: -180, max: 180 // Kinh độ (longitude)
  //     lat: [], //double, optional, min: -90, max: 90 // Vĩ độ (latitude)
  //   }, //optional // Địa điểm diễn ra hoặc địa điểm khởi đầu (nếu dia_diem_dich bằng undefined)

  //   dia_diem_dich: {
  //     dia_diem: [], //string, optional // Địa điểm diễn ra hoặc địa điểm khởi đầu
  //     province_id: [], //IdRef, optional // Mã tỉnh
  //     district_id: [], //IdRef, optional // Mã huyện
  //     lng: [], //double, optional, min: -180, max: 180 // Kinh độ (longitude)
  //     lat: [], //double, optional, min: -90, max: 90 // Vĩ độ (latitude)
  //   }, //optional // Địa điểm địa điểm đích

  //   tieu_de: [], //string, optional // Tiêu đề
  //   noi_dung: [], //string, optional // Nội dung
  // } //optional // Hành trình
  // ],

  thoi_gian_bat_dau: [ValidService.required], //datetime, optional // Thời gian bắt đầu
  thoi_gian_ket_thuc: [ValidService.required], //datetime, optional // Thời gian kết thúc
  so_luong_khach: {
    so_luong: [ValidService.required], //integer, optional, min: 0 // Tổng số lượng khách
    nguoi_lon: [], //integer, optional, min: 0 // Số người lớn
    tre_5_15: [], //integer, optional, min: 0 // Số trẻ từ 5 đến 15 tuổi
    tre_duoi_5: [], //integer, optional, min: 0 // Số trẻ dưới 5 tuổi
  }, //optional // Số lượng khách

  truong_doan: {
    truong_doan_id: [], //IdRef, optional // Mã trưởng đoàn
    ngay_sinh: {
      ngay: [], //integer, optional, min: 1, max: 31 // Ngày
      thang: [], //integer, optional, min: 1, max: 12 // Tháng
      nam: [], //integer, optional // Năm
      ngay_sinh: [], //datetime, optional // Ngày sinh
    }, //optional // Ngày tháng năm sinh

    dien_thoai: [], //string, optional // Số điện thoại
  }, //optional // Thông tin trưởng đoàn

  scan: {
    thong_tin_dieu_tour: [], //of IdRef, optional // Scan các ảnh chụp thông tin điều tour
    ho_so_tour: [] //of IdRef, optional // Các file đính kèm về hồ sơ Tour
  }, //optional // Các ảnh scan

  oto: {
    bien_so_xe: [ValidService.pattern(/^[0-9a-zA-Z. -]*$/, 'Biển số xe không hợp lệ! Chỉ chấp nhận chữ số, chữ cái, dấu trừ, dấu chấm, dấu cách.')], //string, optional // Biển số xe
    tai_xe: {
      ho_ten: [ValidService.pattern(/^[A-Za-z \-\:ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]*$/, 'Tên không đúng')], //string, optional // Họ tên tài xế
      dien_thoai: [ValidService.pattern(/^0\d{9,10}$/, 'Số điện thoại không đúng')], //string, optional // Số điện thoại tài xế
    } //optional // Thông tin tài xế

  }, //optional // Thông tin ô tô

  // khach_san: [{
  //   ten: [], //string, optional // Tên khách sạn
  //   dien_thoai: [], //string, optional // Số điện thoại người phụ trách
  //   ten_nguoi_quan_ly: [], //string, optional // Tên người quản lý
  //   dia_chi: {
  //     dia_chi: [], //string, optional // Địa chỉ khách sạn
  //     province_id: [], //IdRef, optional // Mã tỉnh
  //     lng: [], //double, optional, min: -180, max: 180 // Kinh độ (longitude)
  //     lat: [], //double, optional, min: -90, max: 90 // Vĩ độ (latitude)
  //   }, //optional // Địa chỉ khách sạn
  // }], //optional // Danh sách Khách sạn

  // nha_hang: [{
  //   ten: [], //string, optional // Tên Nhà hàng
  //   dien_thoai: [], //string, optional // Số điện thoại người phụ trách
  //   ten_nguoi_quan_ly: [], //string, optional // Tên người quản lý
  //   dia_chi: {
  //     dia_chi: [], //string, optional // Địa chỉ nhà hàng
  //     province_id: [], //IdRef, optional // Mã tỉnh
  //     lng: [], //double, optional, min: -180, max: 180 // Kinh độ (longitude)
  //     lat: [], //double, optional, min: -90, max: 90 // Vĩ độ (latitude)
  //   }, //optional // Địa chỉ nhà hàng
  // }], //optional // Danh sách Nhà hàng

  anh: {
    anh_dai_dien: undefined,//IdRef, optional // Mã ảnh đại diện của tour (thường là ảnh vuông)
    anh_tour: [], //array of IdRef, optional // Danh sách ảnh chụp của tour
  }, //optional // Các thể loại ảnh của tour
  noi_dung: [], //string, optional // Nội dung thông tin tour
  khach_du_lich_cho_xac_nhan_ids: [], //IdRef, optional // Danh sách khách du lịch
  huong_dan_vien_ids: [], //IdRef, optional // Danh sách hướng dẫn viên

  modelDefault: {
    hanh_trinh: {
      thoi_gian_bat_dau: [], //datetime, optional // Từ ngày/thời điểm
      thoi_gian_ket_thuc: [], //datetime, optional // Đến ngày/thời điểm
      dia_diem: {
        dia_diem: [], //string, optional // Địa điểm diễn ra hoặc địa điểm khởi đầu
        province_id: [], //IdRef, optional // Mã tỉnh
        district_id: [], //IdRef, optional // Mã huyện
        lng: [], //double, optional, min: -180, max: 180 // Kinh độ (longitude)
        lat: [], //double, optional, min: -90, max: 90 // Vĩ độ (latitude)
      }, //optional // Địa điểm diễn ra hoặc địa điểm khởi đầu (nếu dia_diem_dich bằng undefined)

      dia_diem_dich: {
        dia_diem: [], //string, optional // Địa điểm diễn ra hoặc địa điểm khởi đầu
        province_id: [], //IdRef, optional // Mã tỉnh
        district_id: [], //IdRef, optional // Mã huyện
        lng: [], //double, optional, min: -180, max: 180 // Kinh độ (longitude)
        lat: [], //double, optional, min: -90, max: 90 // Vĩ độ (latitude)
      }, //optional // Địa điểm địa điểm đích

      tieu_de: [], //string, optional // Tiêu đề
      noi_dung: [], //string, optional // Nội dung
    },
    khach_san: {
      ten: [], //string, optional // Tên khách sạn
      dien_thoai: [ValidService.pattern(/(84|0[3|5|7|8|9])+([0-9]{8})\b/, 'Số điện thoại không đúng')], //string, optional // Số điện thoại người phụ trách
      ten_nguoi_quan_ly: [], //string, optional // Tên người quản lý
      dia_chi: {
        dia_chi: [], //string, optional // Địa chỉ khách sạn
        province_id: [], //IdRef, optional // Mã tỉnh
        lng: [], //double, optional, min: -180, max: 180 // Kinh độ (longitude)
        lat: [], //double, optional, min: -90, max: 90 // Vĩ độ (latitude)
      }, //optional // Địa chỉ khách sạn
    },
    nha_hang: {
      ten: [], //string, optional // Tên Nhà hàng
      dien_thoai: [ValidService.pattern(/(84|0[3|5|7|8|9])+([0-9]{8})\b/, 'Số điện thoại không đúng')], //string, optional // Số điện thoại người phụ trách
      ten_nguoi_quan_ly: [], //string, optional // Tên người quản lý
      dia_chi: {
        dia_chi: [], //string, optional // Địa chỉ nhà hàng
        province_id: [], //IdRef, optional // Mã tỉnh
        lng: [], //double, optional, min: -180, max: 180 // Kinh độ (longitude)
        lat: [], //double, optional, min: -90, max: 90 // Vĩ độ (latitude)
      }, //optional // Địa chỉ nhà hàng
    }
  }

};

// dữ liệu mẫu các form khác
model.dataFormOther = {
  hanh_trinh: {
    thoi_gian_bat_dau: undefined, //datetime, optional // Từ ngày/thời điểm
    thoi_gian_ket_thuc: undefined, //datetime, optional // Đến ngày/thời điểm
    dia_diem: {
      dia_diem: undefined, //string, optional // Địa điểm diễn ra hoặc địa điểm khởi đầu
      province_id: undefined, //IdRef, optional // Mã tỉnh
      district_id: undefined, //IdRef, optional // Mã huyện
      lng: undefined, //double, optional, min: -180, max: 180 // Kinh độ (longitude)
      lat: undefined, //double, optional, min: -90, max: 90 // Vĩ độ (latitude)
    }, //optional // Địa điểm diễn ra hoặc địa điểm khởi đầu (nếu dia_diem_dich bằng undefined)

    dia_diem_dich: {
      dia_diem: undefined, //string, optional // Địa điểm diễn ra hoặc địa điểm khởi đầu
      province_id: undefined, //IdRef, optional // Mã tỉnh
      district_id: undefined, //IdRef, optional // Mã huyện
      lng: undefined, //double, optional, min: -180, max: 180 // Kinh độ (longitude)
      lat: undefined, //double, optional, min: -90, max: 90 // Vĩ độ (latitude)
    }, //optional // Địa điểm địa điểm đích

    tieu_de: undefined, //string, optional // Tiêu đề
    noi_dung: undefined, //string, optional // Nội dung
  },
  khach_san: {
    ten: undefined, //string, optional // Tên khách sạn
    ten_nguoi_quan_ly: undefined, //string, optional // Tên người quản lý
    dien_thoai: undefined, //string, optional // Số điện thoại người phụ trách
    dia_chi: {
      dia_chi: undefined, //string, optional // Địa chỉ khách sạn
      province_id: undefined, //IdRef, optional // Mã tỉnh
      lng: undefined, //double, optional, min: -180, max: 180 // Kinh độ (longitude)
      lat: undefined, //double, optional, min: -90, max: 90 // Vĩ độ (latitude)
    }, //optional // Địa chỉ khách sạn
  },
  nha_hang: {
    ten: undefined, //string, optional // Tên Nhà hàng
    ten_nguoi_quan_ly: undefined, //string, optional // Tên người quản lý
    dien_thoai: undefined, //string, optional // Số điện thoại người phụ trách
    dia_chi: {
      dia_chi: undefined, //string, optional // Địa chỉ nhà hàng
      province_id: undefined, //IdRef, optional // Mã tỉnh
      lng: undefined, //double, optional, min: -180, max: 180 // Kinh độ (longitude)
      lat: undefined, //double, optional, min: -90, max: 90 // Vĩ độ (latitude)
    }, //optional // Địa chỉ nhà hàng
  }

};

// validation các form khác
model.validFormOther = {
  hanh_trinh: {
    thoi_gian_bat_dau: [ValidService.required], //datetime, optional // Từ ngày/thời điểm
    thoi_gian_ket_thuc: [ValidService.required], //datetime, optional // Đến ngày/thời điểm
    dia_diem: {
      dia_diem: [ValidService.required, ValidService.checkSpaceString], //string, optional // Địa điểm diễn ra hoặc địa điểm khởi đầu
      province_id: [], //IdRef, optional // Mã tỉnh
      district_id: [], //IdRef, optional // Mã huyện
      lng: [], //double, optional, min: -180, max: 180 // Kinh độ (longitude)
      lat: [], //double, optional, min: -90, max: 90 // Vĩ độ (latitude)
    }, //optional // Địa điểm diễn ra hoặc địa điểm khởi đầu (nếu dia_diem_dich bằng undefined

    dia_diem_dich: {
      dia_diem: [], //string, optional // Địa điểm diễn ra hoặc địa điểm khởi đầu
      province_id: [], //IdRef, optional // Mã tỉnh
      district_id: [], //IdRef, optional // Mã huyện
      lng: [], //double, optional, min: -180, max: 180 // Kinh độ (longitude)
      lat: [], //double, optional, min: -90, max: 90 // Vĩ độ (latitude)
    }, //optional // Địa điểm địa điểm đích

    tieu_de: [ValidService.required, ValidService.checkSpaceString], //string, optional // Tiêu đề
    noi_dung: [ValidService.required, ValidService.checkSpaceString], //string, optional // Nội dung
    phieu_dieu_tour_id: [] //IdRef, optional // Mã phiếu điều tour
  },
  khach_san: {
    ten: [ValidService.required, ValidService.checkSpaceString], //string, optional // Tên khách sạn
    dien_thoai: [ValidService.required, ValidService.pattern(/(84|0[3|5|7|8|9])+([0-9]{8})\b/, 'Số điện thoại không đúng')], //string, optional // Số điện thoại người phụ trách
    ten_nguoi_quan_ly: [ValidService.required, ValidService.checkSpaceString , ValidService.pattern(/^[A-Za-z \-\:ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]*$/, 'Tên không đúng')], //string, optional // Tên người quản lý
    dia_chi: {
      dia_chi: [], //string, optional // Địa chỉ khách sạn
      province_id: [], //IdRef, optional // Mã tỉnh
      lng: [], //double, optional, min: -180, max: 180 // Kinh độ (longitude)
      lat: [], //double, optional, min: -90, max: 90 // Vĩ độ (latitude)
    }, //optional // Địa chỉ khách sạn
  },
  nha_hang: {
    ten: [ValidService.required, ValidService.checkSpaceString], //string, optional // Tên Nhà hàng
    dien_thoai: [ValidService.required, ValidService.pattern(/(84|0[3|5|7|8|9])+([0-9]{8})\b/, 'Số điện thoại không đúng')], //string, optional // Số điện thoại người phụ trách
    ten_nguoi_quan_ly: [ValidService.required, ValidService.checkSpaceString , ValidService.pattern(/^[A-Za-z \-\:ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]*$/, 'Tên không đúng')], //string, optional // Tên người quản lý
    dia_chi: {
      dia_chi: [], //string, optional // Địa chỉ nhà hàng
      province_id: [], //IdRef, optional // Mã tỉnh
      lng: [], //double, optional, min: -180, max: 180 // Kinh độ (longitude)
      lat: [], //double, optional, min: -90, max: 90 // Vĩ độ (latitude)
    }, //optional // Địa chỉ nhà hàng
  }
};

model.excelKhachDuLich = {
  formModel: {
    //so_the: undefined, // string, optional // Mã thẻ
    ho_ten: { // object, optional
      ho_ten: undefined, // string, optional // Họ tên đầy đủ
    },
    email: undefined, // string, optional // Email
    dien_thoai: undefined, // string, optional // Số điện thoại
    so_the: undefined, //Số thẻ/Mã MS - mới bổ sung
    gioi_tinh: undefined, // integer, optional // Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
    ngay_sinh: { // object, optional // Ngày tháng năm sinh
      ngay: undefined, // integer, optional // Ngày
      thang: undefined, // integer, optional // Tháng
      nam: undefined, // integer, optional // Năm
      ngay_sinh: undefined, // datetime, optional // Ngày sinh
    },
    giay_to: [
      {
        loai_giay_to: undefined, //string, optional // Loại giấy tờ
        so_giay_to: undefined, //string, optional // Số giấy tờ
        noi_cap: undefined, //string, optional // Nơi cấp
        ngay_cap: undefined, //datetime, optional // Ngày cấp
        ngay_het_han: undefined, //datetime, optional // Ngày hết hạn
      }
    ], //array of object, optional // Giấy tờ, ví dụ: CMT, CCCD, Họ chiếu
    quoc_tich: { //object, optional // Quốc tịch
      quoc_tich_id: undefined, // IdRef, optional // Mã quốc tịch
      ten_quoc_tich: undefined, // string, optional // Tên quốc tịch
    },
    dia_chi: { // object, optional // Địa chỉ
      province_id: undefined, // IdRef, optional // Mã tỉnh/TP
      province_name: undefined, // string, optional // Tên tỉnh/TP
      district_id: undefined, // IdRef, optional // Mã quận/huyện
      district_name: undefined, // string, optional // Tên quận/huyện
      dia_chi: undefined, // string, optional // Địa chỉ đầy đủ
    },
    //avatar_id: undefined, // IdRef, optional // Mã ảnh đại diện
  },


  //Thay đổi thứ tự config với file excel bằng trường index, trường code phải sửa cả template, name không dùng tới
  configIndex:
    [
      {
        index: 0,
        code: "excel_stt",
        name: "STT"
      },
      {
        index: 1,
        code: "excel_ho_ten",
        name: "Họ và tên khách"
      },
      {
        index: 2,
        code: "excel_dien_thoai",
        name: "Số điện thoại"
      },
      {
        index: 3,
        code: "excel_ma_ms",
        name: "Mã MS"
      },
      {
        index: 4,
        code: "excel_email",
        name: "Email"
      },
      {
        index: 5,
        code: "excel_gioi_tinh",
        name: "Giới tính"
      },
      {
        index: 6,
        code: "excel_ngay_sinh",
        name: "Ngày sinh"
      },
      {
        index: 7,
        code: "excel_thang_sinh",
        name: "Tháng sinh"
      },
      {
        index: 8,
        code: "excel_nam_sinh",
        name: "Năm sinh"
      },
      {
        index: 9,
        code: "excel_dia_chi",
        name: "Địa chỉ"
      },
      {
        index: 10,
        code: "excel_province_name",
        name: "Tỉnh/Thành phố"
      },
      {
        index: 11,
        code: "excel_ten_quoc_tich",
        name: "Quốc tịch"
      },
      {
        index: 12,
        code: "excel_loai_giay_to",
        name: "Loại giấy tờ"
      },
      {
        index: 13,
        code: "excel_so_giay_to",
        name: "Số giấy tờ"
      },
      {
        index: 14,
        code: "excel_noi_cap",
        name: "Nơi cấp"
      },
      {
        index: 15,
        code: "excel_ngay_cap",
        name: "Ngày cấp"
      },
      {
        index: 16,
        code: "excel_thang_cap",
        name: "Tháng cấp"
      },
      {
        index: 17,
        code: "excel_nam_cap",
        name: "Năm cấp"
      },
      {
        index: 18,
        code: "excel_ngay_het_han",
        name: "Ngày hết hạn"
      },
      {
        index: 19,
        code: "excel_thang_het_han",
        name: "Tháng hết hạn"
      },
      {
        index: 20,
        code: "excel_nam_het_han",
        name: "Năm hết hạn"
      },
    ]
};


model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100, 500],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "",
  defaultSort: ["thoi_gian_bat_dau", "descending"],
  filters: "",
  recordSelected: [],
  dataSearch: {
    value: {
      ten_tour: "",
      ten_doan: ""
    },
    valid: {
      ten_tour: [],
      ten_doan: []
    },
    operator: {
      ten_tour: ":regex_i:", //:regex:, $vn_text=Viêt nam
      ten_doan: ":regex_i:",
      thoi_gian_bat_dau: ":in_that_day:",
      thoi_gian_ket_thuc: ":in_that_day:"
    }
  }
  // so_sao:[]
};

export default model;
